import * as yup from 'yup'

export class SettingsMichiganTitleFeeDto {
  michiganTitleFee?: number = undefined
}

export const settingsMichiganTitleFeeValidationSchema = yup.object<SettingsMichiganTitleFeeDto>({
  michiganTitleFee: yup
    .number()
    .min(0, 'Michigan Title Fee cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Michigan Title Fee cannot be more than $999,999,999,999.99.')
    .required('Michigan Title Fee is required.')
})
